import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../util/core/Fetch';
import { useUserCity } from '../../../../Common/hooks/useUserCity';

const useCbo = () => {
    const { data } = useUserCity();

    return useQuery({
        queryKey: ['cbo', data?.governance_room_geo_city_id],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend +
                    'governanceroom/esus/getcbo',
                {
                    filters: {
                        governance_room_geo_city_id:
                            data?.governance_room_geo_city_id
                    }
                }
            );
        },
        staleTime: Infinity,
        enabled: !!data?.governance_room_geo_city_id
    });
};

export default useCbo;